import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { CellContext } from '@tanstack/react-table';
import { utcToZonedTime } from 'date-fns-tz';

import { AdaptiveTableCell } from '@components/common';

import { formatDate } from '@utils/kpi-utils/date';

import { formatTemplateDefault, formatTemplateWithTime, timezoneUTC } from '@constants/common';
import { routes } from '@constants/routes';

import RequestsActionsColumnCell from '../RequestsActionsColumnCell';
import NetworkOperatorCell from './NetworkOperatorCell';

const {
	adminPanel: {
		index,
		incomingRequestsPath,
	},
} = routes;

export const getColumns = (navigate: NavigateFunction) => ([
	{
		header: 'Request Id',
		accessorKey: 'requestId',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const requestId = getValue();

			return <AdaptiveTableCell text={requestId} />;
		},
	},
	{
		header: 'Organisation',
		accessorKey: 'networkOperator',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const networkOperator = getValue();

			return (
				<NetworkOperatorCell
					avatarId={networkOperator?.avatar?.id}
					name={networkOperator?.name}
				/>
			);
		},
	},
	{
		header: 'Request Date',
		accessorKey: 'createdAt',
		cell: ({ getValue }: CellContext<any, any>) => {
			const createdAt = getValue();
			const date = formatDate(utcToZonedTime(createdAt, timezoneUTC), formatTemplateWithTime);

			return <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'Start Rent Date',
		accessorKey: 'startRentDate',
		cell: ({ getValue }: CellContext<any, any>) => {
			const startRentDate = getValue();
			const date = formatDate(utcToZonedTime(startRentDate, timezoneUTC), formatTemplateDefault);

			return <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'End Rent Date',
		accessorKey: 'endRentDate',
		cell: ({ getValue }: CellContext<any, any>) => {
			const endRentDate = getValue();
			const date = formatDate(utcToZonedTime(endRentDate, timezoneUTC), formatTemplateDefault);

			return <AdaptiveTableCell text={date} />;
		},
	},
	{
		header: 'Request Status',
		accessorKey: 'requestStatus',
		cell: ({ getValue }: CellContext<any, any>) => {
			const requestStatus = getValue();

			return <AdaptiveTableCell text={requestStatus?.title} />;
		},
	},
	{
		header: 'Actions',
		accessorKey: 'actions',
		enableSorting: false,
		cell: ({ row }: CellContext<any, any>) => {
			const id = row?.original?.requestDbId;

			const handleView = () => {
				if (!id) return;

				navigate(`${index}${incomingRequestsPath}/${id}`);
			};

			return <RequestsActionsColumnCell handleView={handleView} />;
		},
	},
]);
